import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userReducer from './user-state/UserState';
import PlayerReducer from './player-state/playerState';
import EditorReducer from './editor-state/editorState';
import shellReducer from './shell-state/shellState';
import FilmStripReducer from './filmstrip-state/filmstrip-state';
import UploadReducer from './upload-state/upload-state';
import deviceState from './device-state';

function initStore() {
  return configureStore({
    reducer: {
      shell: shellReducer,
      user: userReducer,
      editor: EditorReducer,
      player: PlayerReducer,
      filmstrip: FilmStripReducer,
      upload: UploadReducer,
      device: deviceState,
    },
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredPaths: [
            'shell.sharedModalState.authCallBack',
            'upload.uploadState.cancelToken',
            'upload.uploadPayload.file',
          ],
          ignoredActionPaths: ['payload'],
        },
      }),
  });
}

const store = initStore();

export type AppState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;

export default store;
